var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronsUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 11.7L12 7.4L16.3 11.7C16.5 11.9 16.8 12 17 12C17.2 12 17.5 11.9 17.7 11.7C18.1 11.3 18.1 10.7 17.7 10.3L12.7 5.3C12.3 4.9 11.7 4.9 11.3 5.3L6.3 10.3C5.9 10.7 5.9 11.3 6.3 11.7C6.7 12.1 7.3 12.1 7.7 11.7ZM12.7 12.3C12.3 11.9 11.7 11.9 11.3 12.3L6.3 17.3C5.9 17.7 5.9 18.3 6.3 18.7C6.7 19.1 7.3 19.1 7.7 18.7L12 14.4L16.3 18.7C16.5 18.9 16.8 19 17 19C17.2 19 17.5 18.9 17.7 18.7C18.1 18.3 18.1 17.7 17.7 17.3L12.7 12.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronsUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconChevronsUp.8444198bab018923812f6d425c5a6364.svg";